import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationItem, NotificationType } from '@data/schema/notificationitem';

@Component({
  selector: 'app-contextual-notification',
  templateUrl: './contextual-notification.component.html',
  styleUrls: ['./contextual-notification.component.scss'],
})
export class ContextualNotificationComponent {
  @Input() set notification(notification: NotificationItem) {
    this._notification = notification;
    this.notificationSet();
  }

  get notification(): NotificationItem {
    return this._notification;
  }

  _notification: NotificationItem;
  isDisplayed: boolean = false;
  readonly timeoutDuration: number = 5000;

  constructor(private router: Router) {}

  getAlertClass(message: NotificationItem) {
    if (!message) return;
    const classes = ['notification'];
    const notifTypeClasses = {
      [NotificationType.Success]: 'notification__success',
      [NotificationType.Error]: 'notification__error',
      [NotificationType.Warning]: 'notification__warning',
      [NotificationType.Info]: 'notification__info',
    };
    classes.push(notifTypeClasses[message.messageType]);
    return classes.join(' ');
  }

  notificationSet() {
    if (!this._notification?.disableTimeout) {
      setTimeout(() => {
        this._notification = undefined;
      }, this.timeoutDuration);
    }
  }

  closeNotifications() {
    this.isDisplayed = false;
    this.notification = null;
  }
}
